<script>
import '@/assets/css/krit.css'

export default {
  name: 'kritHeader',
}
</script>

<template>
  <div class="krit">
    <router-link to="/krit">
      <div class="logo_wrap">
        <img src="@/assets/img/krit/krit_logo.png" />
      </div>
      <img src="@/assets/img/krit/krit_banner_250807.png" />
    </router-link>
  </div>
</template>